import { render, staticRenderFns } from "./comFunUser.vue?vue&type=template&id=13e1961c&scoped=true&"
import script from "./comFunUser.vue?vue&type=script&lang=js&"
export * from "./comFunUser.vue?vue&type=script&lang=js&"
import style0 from "./comFunUser.vue?vue&type=style&index=0&id=13e1961c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e1961c",
  null
  
)

export default component.exports